import React, { useState } from "react";
import "./ai-campaign-type.css";

const ALL_TYPES = [
  { key: "phishing",   label: "Phishing"   },
  { key: "ransomware", label: "Ransomware" },
  { key: "smishing",   label: "Smishing"   },
  { key: "whatsapp",   label: "WhatsApp"   },
  { key: "qrcode",     label: "QR Code"    },
  { key: "attachment", label: "Attachment" },
  { key: "vishing",    label: "Vishing"    },
];

const TRAINING_TYPES = ["phishing", "smishing", "whatsapp", "qrcode"];

const AiCampaignType = ({ onDone }) => {
  const [mode, setMode]       = useState("simulation");
  const [selected, setSelected] = useState(null);

  const visibleTypes =
    mode === "simulation"
      ? ALL_TYPES
      : ALL_TYPES.filter((t) => TRAINING_TYPES.includes(t.key));

  const handleSelect = (key) => setSelected(key === selected ? null : key);

  return (
    <div className="act-wrapper">

      {/* Description */}
      <p className="act-description">
        Choose a campaign mode and select the type of attack simulation you want to run. Each type targets a different channel or threat scenario.
      </p>

      {/* Radio buttons */}
      <div className="act-radio-group">
        <label className={`act-radio-label${mode === "simulation" ? " active" : ""}`}>
          <input
            type="radio"
            name="mode"
            value="simulation"
            checked={mode === "simulation"}
            onChange={() => { setMode("simulation"); setSelected(null); }}
          />
          Simulation
        </label>
        <label className={`act-radio-label${mode === "simulation+training" ? " active" : ""}`}>
          <input
            type="radio"
            name="mode"
            value="simulation+training"
            checked={mode === "simulation+training"}
            onChange={() => { setMode("simulation+training"); setSelected(null); }}
          />
          Simulation + Training
        </label>
      </div>

      {/* Type badges */}
      <div className="act-badge-group">
        {visibleTypes.map(({ key, label }) => (
          <button
            key={key}
            className={`act-badge${selected === key ? " selected" : ""}`}
            onClick={() => handleSelect(key)}
          >
            {label}
          </button>
        ))}
      </div>

      {/* Done button */}
      {selected && (
        <div className="act-footer">
          <button
            className="act-done-btn"
            onClick={() => onDone && onDone({ mode, type: selected })}
          >
            Done
          </button>
        </div>
      )}

    </div>
  );
};

export default AiCampaignType;
